<!-- 之前的选择 -->
<template>
  <nf-card borderInnerSize="0" round=".2rem" style="margin-top: 0.2rem">
    <div class="game-1-box">
      <!-- <div>{{ nickname }}之前的选择：</div> -->
      <div>之前的选择：</div>
      <div class="game-1-box-step">
        <template v-if="formValue.length > 0">
          <div class="game-1-box-step-left">
            <div
              class="game-1-box-step-left-item"
              v-for="(_, index) in formValue"
              :key="index"
            ></div>
            <!-- <Steps>
              <Step v-for="(_, index) in formValue" :key="index" />
            </Steps> -->
          </div>
          <div class="game-1-box-step-right">
            <template v-for="(item, index) in formValue">
              <div class="game-1-box-step-right-item" :key="index">
                <div class="game-1-box-step-right-item-text">
                  <div class="game-1-box-step-right-item-text-list">
                    <div class="game-1-box-step-right-item-text-list-title">
                      <!-- 第 {{ "{" + item.roundNum + "}" }} 轮：{{
                        "{" + item.cateName + "}："
                      }} -->
                      第
                      <span style="font-weight: bold">{{ item.roundNum }}</span>
                      轮：
                      <span style="font-weight: bold"
                        >{{ item.cateName }}：</span
                      >
                    </div>
                    <template v-for="(tagItem, tagIndex) in item.records">
                      <div
                        class="game-1-box-step-right-item-text-list-name"
                        :key="tagItem.id"
                      >
                        {{ tagItem.cardName }}
                        {{ tagIndex + 1 < item.records.length ? "、" : "" }}
                      </div>
                    </template>
                  </div>

                  <div class="game-1-box-step-right-item-text-icon">
                    <!-- 查看按钮 -->
                    <Icon
                      v-if="showCardList[index]"
                      @click="showCardHandler(index)"
                      :name="ShowImg"
                      color="#73ddef"
                    ></Icon>
                    <Icon
                      v-else
                      @click="showCardHandler(index)"
                      :name="HiddenImg"
                    ></Icon>
                  </div>
                </div>

                <div>
                  <!-- 展示卡片还是转轮，因为多个转盘会降低性能，用if -->
                  <template v-if="showCardList[index]">
                    <template v-if="isShowCard(item.records)">
                      <div style="display: inline">
                        <WheelRecord :value="item.records"></WheelRecord>
                      </div>
                    </template>
                    <template v-else>
                      <div class="game-1-box-step-right-item-left-img">
                        <Grid :column-num="3" :border="false">
                          <GridItem
                            v-for="(subitem, subindex) in item.records"
                            :key="subindex"
                          >
                            <div
                              class="game-1-box-step-right-item-left-img-item"
                              :class="{ active: activeCard == subitem.id }"
                              @click="activeCardHandle(subitem)"
                            >
                              <VanImage
                                height="100%"
                                :src="
                                  subitem.isFront != 1
                                    ? subitem.reverseImg
                                    : subitem.frontImg
                                "
                                fit="fill"
                                radius="5"
                              />
                            </div>
                          </GridItem>
                        </Grid>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div>暂无</div>
        </template>
      </div>
    </div>
  </nf-card>
</template>

<script>
import NfCard from "@/components/game-ui/NfCard.vue";
import {
  Icon,
  Grid,
  GridItem,
  Image as VanImage,
  Step,
  Steps,
  ImagePreview,
} from "vant";
import ShowImg from "@/assets/game/show.png";
import HiddenImg from "@/assets/game/hidden.png";
import { getGameConfig } from "@/views/game/config";
import WheelRecord from "./WheelRecord.vue";
export default {
  components: {
    NfCard,
    Icon,
    Grid,
    GridItem,
    VanImage,
    Step,
    Steps,
    ImagePreview,
    WheelRecord,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
    nickname: {
      type: String,
      default: "我",
    },
  },
  data() {
    return {
      showCardList: {},
      ShowImg,
      HiddenImg,
    };
  },
  computed: {
    formValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", {
          ...val,
        });
      },
    },
  },
  watch: {
    value: {
      handler(list) {
        list.map((item, index) => {
          this.$set(this.showCardList, index, false);
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    showCardHandler(index) {
      this.$set(this.showCardList, index, !this.showCardList[index]);
    },
    activeCardHandle(item) {
      this.activeCard = item.id;
      ImagePreview([item.isFront != 1 ? item.reverseImg : item.frontImg]);
    },
    // 判断展示卡片还是转轮
    isShowCard(item) {
      if (item.length > 0) {
        const config = getGameConfig(item[0].cateId, item[0].secondCateId);
        // return item.isFront != 1 ? item.reverseImg : item.frontImg;
        if (config.visibleType == "wheel") {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.game-1-box {
  &-step {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.2rem;
    width: 100%;
    &-left {
      height: 100%;
      border-radius: 0.1rem;
      width: 0.2rem;
    }
    &-right {
      flex: 1;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      width: 100%;
      &-item {
        // display: flex;
        // justify-content: space-between;
        display: flex;
        flex-direction: column;
        width: 100%;
        &-left {
          display: flex;
          flex-wrap: wrap;
          margin: 0.1rem 0;
          &-text {
            font-size: 0.25rem;
          }
          &-icon {
            display: inline-block;
          }

          &-img {
            width: 100%;
            &-item {
              // width: 1.5rem;
              // height: 2rem;
              // margin: 0.1rem;
            }
          }
        }
        &-text {
          width: 100%;
          display: flex;

          &-list {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
}
</style>

<style>
::v-deep .van-grid-item__content {
  background-color: inherit !important;
}
</style>
